export enum Displays {
  INLINE = 'inline',
  INLINE_BLOCK = 'inline-block',
  BLOCK = 'block',
  TABLE = 'table',
  FLEX = 'flex',
  INLINE_FLEX = 'inline-flex'
}
